const singleShotList = {
    path: 'singleShotList',
    component: resolve => require(['@/pages/admin/message/singleShot/index.vue'], resolve)
}

export default singleShotList